
export default {
  data() {
    return {
      messages: []
    }
  },
  computed: {
    stateMessages() {
      return this.$store.getters.getMessages
    }
  },
  created() {
    this.setMessages()
    this.$nuxt.$on('setMessages', () => {
      this.setMessages()
    })
    this.$nuxt.$on('showToast', () => {
      this.showToast()
    })
  },
  mounted() {
    this.showToast()
  },
  methods: {
    setMessages() {
      this.messages =  JSON.parse(JSON.stringify(this.stateMessages))
    },
    showToast() {
      if (this.$refs.toasts !== undefined) {
        this.$refs.toasts.forEach((toast) => {
          const item = new this.$bootstrap.Toast(toast)
          item.show()
        })
        this.$store.dispatch('setMessages', [])
      }
    }
  }
}
